// removed by extract-text-webpack-plugin
module.exports = {"loader":"Spinner__loader__UBmsk","load8":"Spinner__load8__Yvr9N","center":"Spinner__center__2ckA7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 149
// module chunks = 0